import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dot", "label"]

  connect() {
    this.observer = new MutationObserver(() => this.update())
    this.source = document.querySelector("turbo-cable-stream-source")
    if (this.source) {
      this.observer.observe(this.source, { attributes: true, attributeFilter: ["connected"] })
    }
    this.update()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  update() {
    const connected = this.source?.hasAttribute("connected")
    this.dotTarget.className = connected
      ? "relative flex h-2 w-2"
      : "relative flex h-2 w-2"

    const ping = this.dotTarget.querySelector("[data-ping]")
    const solid = this.dotTarget.querySelector("[data-solid]")

    if (connected) {
      ping.className = "absolute inline-flex h-full w-full animate-ping rounded-full bg-success opacity-75"
      solid.className = "relative inline-flex h-2 w-2 rounded-full bg-success"
      this.labelTarget.textContent = "Live"
      this.labelTarget.className = "font-semibold text-success"
    } else {
      ping.className = "hidden"
      solid.className = "relative inline-flex h-2 w-2 rounded-full bg-warning"
      this.labelTarget.textContent = "Connecting…"
      this.labelTarget.className = "font-semibold text-warning"
    }
  }
}
